import { ISKULevelPlanningEditAllRow } from '../../../interfaces/sku-level-sales-plan-edit-all.interface';

export const grandTotal = (row: ISKULevelPlanningEditAllRow[], isNew: boolean): number => {
  const total = row.reduce((rInit, row) =>
    rInit + row.w.reduce((wInit, w) =>
    wInit + (isNew ? w.value : w.oldValue), 0), 0);
  return Math.round(total);
};

export const horizontalTotal = (row: ISKULevelPlanningEditAllRow, isNew: boolean): number => {
  const total = row.w.reduce((wInit, w) => wInit + (isNew ? w.value : w.oldValue), 0);
  return Math.round(total);
};

export const horizontalFutureTotal = (row: ISKULevelPlanningEditAllRow, isNew: boolean): number => {
  const total = row.w.filter(w => !w.isP).reduce((wInit, w) => wInit + (isNew ? w.value : w.oldValue), 0);
  return Math.round(total);
};

export const remainingHorizontalTotal = (row: ISKULevelPlanningEditAllRow, isNew: boolean): number => {
  const editedTotal = row.w.reduce((wInit, w) => wInit + ((w.isEdited || w.isP) ? w.value : 0), 0);
  const total = horizontalTotal(row, isNew);
  return Math.round(total - editedTotal);
};

export const horizontalPlanUnitTotal = (row: ISKULevelPlanningEditAllRow): number => {
  const total = row.w.reduce((wInit, w) =>
    wInit + w.rmsr.reduce((rmsrInit, rmsr) =>
    rmsrInit + (rmsr.n === 'qty_quota' ? rmsr.v : 0), 0), 0);
  return Math.round(total);
};

export const remainingHorizontalPlanUnitTotal = (row: ISKULevelPlanningEditAllRow): number => {
  const editedTotal = row.w.filter(w => w.isEdited || w.isP)
    .reduce((wInit, w) =>
      wInit + w.rmsr.reduce((rmsrInit, rmsr) =>
      rmsrInit + (rmsr.n === 'qty_quota' ? rmsr.v : 0), 0), 0);
  const total = horizontalPlanUnitTotal(row);
  return Math.round(total - editedTotal);
};

export const verticalTotal = (row: ISKULevelPlanningEditAllRow[], weekIdx: number, isNew: boolean): number => {
  const total = row.reduce((rInit, row) => rInit + (isNew ? (row.w[weekIdx]?.value || 0) : row.w[weekIdx]?.oldValue || 0), 0);
  return Math.round(total);
};

export const remainingVerticalTotal = (rows: ISKULevelPlanningEditAllRow[], weekIdx: number, isNew: boolean): number => {
  const editedTotal = rows.reduce((rInit, row) =>
    rInit + ((row.w[weekIdx]?.isEdited || row.w[weekIdx]?.isP) ? (row.w[weekIdx]?.value || 0) : 0), 0);
  const total = verticalTotal(rows, weekIdx, isNew);
  return Math.round(total - editedTotal);
};
